import { render, staticRenderFns } from "./ProgressBars.vue?vue&type=template&id=54913273"
import script from "./ProgressBars.vue?vue&type=script&lang=js"
export * from "./ProgressBars.vue?vue&type=script&lang=js"
import style0 from "./ProgressBars.vue?vue&type=style&index=0&id=54913273&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports